import {Component, OnInit, ViewChild} from '@angular/core';
import {User} from './user';
import {Group} from '../group/group';
import {Router} from '@angular/router';
import {UserService} from './user.service';
import {GroupService} from '../group/group.service';
import {NgForm} from '@angular/forms';
import {DelConfModalComponent} from '../../shared/delete-confirmation-modal.component';
import {ActivateConfModalComponent} from '../../shared/activate-confirmation-modal.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {user} from '../authenticate/mock-user';
import {LoginService} from '../login/login.service';
import {Observable} from 'rxjs/Observable';
import {PersonService} from '../person/person.service';
import {CreatePersonModalComponent} from '../person/create-person/create-person-modal.component';
import {Person} from '../person/person';
import {LocaleCustomUnity} from '../../pipes/custom-locale.pipe';
import { TranslateService } from '@ngx-translate/core';
import { ErrorBoxService } from '../../shared/error-box/error-box.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {

  users: User[];
  filteredUsers: User[];
  userData: any;
  processingDeleteRequest: boolean = false;
  //dtOptions: DataTables.Settings = {};

  showCreateUserOffcanvas: boolean = false;
  showViewUserOffcanvas: boolean = false;
  selectedUser: any = null;
  loadingUsers: boolean =false;
  searchTerm: string = '';
  showDisabledUser: boolean = false;

  constructor(
    private router: Router,
    private userService: UserService,
    private groupService: GroupService,
    private modalService: NgbModal,
    private loginService: LoginService,
    private localeCustomUnity: LocaleCustomUnity,
    private personService: PersonService,
    private translate: TranslateService,
    private errorBox: ErrorBoxService
  ) { }

  ngOnInit() {
    this.getUsers();
    this.getUserData();
  }

  getUsers(): void {


    this.loadingUsers = true;
    this.userService.getUsers()
      .then(users => {
        this.users = users;
        this.filteredUsers = users;

        this.loadingUsers = false;

      }).catch(error => {

        this.loadingUsers = false;
      });


  }

  openDeleteModal(user) {
    const modal = this.modalService.open(DelConfModalComponent, {
      backdrop: 'static',
      keyboard: false,
      // size: 'sm',
      windowClass: 'rmv-modal',
    });
    modal.componentInstance.text = '<b>' + user.person.name + ' ' + user.person.surname + '</b>, ' + user.email;
    modal.componentInstance.type = 'user';
    modal.result.then((result) => {
      if (result === 'Accept') {
        this.removeUser(user.id);
      }
    });
  }

  removeUser(id: number): void {
    this.processingDeleteRequest = true;
    this.userService.deleteUser(id)
      .then(response => {
        this.processingDeleteRequest = false;
        this.errorBox.success('User removed successfully.');
        this.getUsers();

      }).catch(error => {
        this.processingDeleteRequest = false;
        this.errorBox.error('Eror, try again');

      });
  }

  getUserData() {

    this.loginService.getUser()
      .then(user => {
        this.userData = user;

      }).catch(error => {

      });
  }

  canManupulateUsers(){
    if (!_.isNull(this.userData) && !_.isUndefined(this.userData) ){
      return User.hasRole(this.userData.user, 'SUPER_ADMIN');
    }

    return false;
  }

  // funcion ordenar
  sort(colName) {

    this.users.sort((a, b) => a[colName] > b[colName] ? 1 : a[colName] < b[colName] ? -1 : 0)
  }

  openCreateUserOffcanvas() {
    this.showCreateUserOffcanvas = true;
  }

  closeCreateUserOffcanvas() {
    this.showCreateUserOffcanvas = false;
  }

  onUserCreated(user: any) {
    this.getUsers(); // Refresh the users list
    this.showCreateUserOffcanvas = false;
  }

  openViewUserOffcanvas(user: any) {
    this.selectedUser = user;
    this.showViewUserOffcanvas = true;
  }

  closeViewUserOffcanvas() {
    this.showViewUserOffcanvas = false;
    this.selectedUser = null;
  }

  onUserUpdated(user: any) {
    this.getUsers(); // Refresh the users list
    this.showViewUserOffcanvas = false;
  }

  filterUsers() {
    if (!this.searchTerm) {
      this.filteredUsers = this.users;
      return;
    }

    const term = this.searchTerm.toLowerCase();
    this.filteredUsers = this.users.filter(user => {
      return (user.person && user.person.name && user.person.name.toLowerCase().includes(term)) ||
             (user.person && user.person.surname && user.person.surname.toLowerCase().includes(term)) ||
             (user.person && user.person.email && user.person.email.toLowerCase().includes(term)) ||
             (user.person && user.person.phone && user.person.phone.toLowerCase().includes(term)) ||
             (user.group && user.group.name && user.group.name.toLowerCase().includes(term)) ||
             (user.person && user.person.office && user.person.office.company && user.person.office.company.name && user.person.office.company.name.toLowerCase().includes(term)) ||
             (user.person && user.person.city && user.person.city.nameUtf8 && user.person.city.nameUtf8.toLowerCase().includes(term));
    });
  }

  changeShowDisabledUser() {
    this.showDisabledUser = !this.showDisabledUser;
  }

 openActivateModal(user) {
    const modal = this.modalService.open(ActivateConfModalComponent, {
      backdrop: 'static',
      keyboard: false,
      // size: 'sm',
      // windowClass: 'rmv-modal',
    });

    // Crear un mensaje más descriptivo
    const userName = user.person.name && user.person.surname
      ? `<b>${user.person.name} ${user.person.surname}</b>`
      : `<b>${user.person.name || 'Sin nombre'}</b>`;

    const userEmail = user.email ? ` (${user.email})` : '';

    modal.componentInstance.text = `${userName}${userEmail}`;
    modal.componentInstance.type = 'usuario';
    modal.result.then((result) => {
      if (result === 'Accept') {
        this.activateUser(user);
      } else { }
    });
  }

  activateUser(user: any): void {
    this.userService.activateUser(user)
      .then(response => {
        // Solo emitir evento al componente padre, que se encarga de actualizar la lista
        this.getUsers();
        this.errorBox.success('User activated successfully');
      })
      .catch(error => {
        if (error.status === 404) {
          this.errorBox.error(JSON.parse(error._body).error.message);
        }
      });
  }
}
